import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import EditIcon from "@mui/icons-material/EditOutlined";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import TooltipText from "../../common/tooltipText";
import "../../../styles/admin/promptCard.scss";

const PromptCard = ({ prompt, onClick, onEdit, onDelete, onToggleActive, isEval = false }) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const menuOpen = Boolean(menuAnchorEl);

  const handleMenuOpen = (event) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (event) => {
    if (event) {
      event.stopPropagation();
    }
    setMenuAnchorEl(null);
  };

  const handleEditClick = (event) => {
    event.stopPropagation();
    handleMenuClose();
    if (onEdit) onEdit();
  };

  const handleDeleteClick = (event) => {
    event.stopPropagation();
    handleMenuClose();
    if (onDelete) onDelete();
  };
  const formatUpdatedAt = (value) => {
    if (!value) return "N/A";
    try {
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return String(value);
      return d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "2-digit",
      });
    } catch (e) {
      return String(value);
    }
  };

  return (
    <div
      className="prompt-card"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if ((e.key === "Enter" || e.key === " ") && onClick) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="prompt-card__header">
        <div className="prompt-card__title">
          <TooltipText
            text={prompt?.name || "Untitled Prompt"}
            className="prompt-card__title-text"
          />
        </div>
        <div className="prompt-card__header-actions">
          {!isEval && (
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                if (onToggleActive) onToggleActive();
              }}
              aria-label={prompt?.is_active ? "Deactivate" : "Activate"}
            >
              <PowerSettingsNewIcon
                fontSize="small"
                className={
                  prompt?.is_active
                    ? "prompt-card__status-icon prompt-card__status-icon--active"
                    : "prompt-card__status-icon prompt-card__status-icon--inactive"
                }
              />
            </IconButton>
          )}
          <div className="prompt-card__menu">
            <IconButton
              size="small"
              onClick={handleMenuOpen}
              aria-label="Actions"
            >
              <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu
              anchorEl={menuAnchorEl}
              open={menuOpen}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                sx: {
                  mt: 0.5,
                  minWidth: 140,
                  borderRadius: "10px",
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
                  border: "1px solid var(--secondary-border)",
                  py: 0.5,
                },
              }}
              MenuListProps={{
                disablePadding: true,
              }}
            >
              <MenuItem
                onClick={handleEditClick}
                sx={{
                  fontSize: "var(--fs-sm)",
                  py: 1,
                  px: 1.25,
                  color: "var(--color-text-dark)",
                  "&:hover": {
                    backgroundColor: "var(--hover-bg, #f3f4f6)",
                  },
                }}
              >
                <span className="model-card__actions-item-label">
                  <EditIcon fontSize="small" /> Edit
                </span>
              </MenuItem>
              {!isEval && (
                <MenuItem
                  onClick={handleDeleteClick}
                  sx={{
                    fontSize: "var(--fs-sm)",
                    py: 1,
                    px: 1.25,
                    color: "var(--color-error)",
                    "&:hover": {
                      backgroundColor: "var(--hover-bg, #f3f4f6)",
                    },
                  }}
                >
                  <span className="model-card__actions-item-label">
                    <DeleteIcon fontSize="small" /> Delete
                  </span>
                </MenuItem>
              )}
            </Menu>
          </div>
        </div>
      </div>

      <div className="prompt-card__body">
        <div className="prompt-card__label">
          Type: {prompt?.persona_type?.replaceAll("_", " ") || "--"}
        </div>
      </div>

      <div className="prompt-card__footer">
        <span className="prompt-card__meta">
          Updated: {formatUpdatedAt(prompt?.updated_at || prompt?.created_at)}
        </span>
      </div>
    </div>
  );
};

export default PromptCard;
